import { IUserRights } from '@/sub-luca-plugin/types';
import { CloseOutlined, QuestionCircleOutlined } from '@/sub-luca-plugin/compatible-components/svg-icons';
import './index.scss';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';

interface Subject {
    id: string | number;
    name: string;
}

interface RightsInfoProps {
    userRights?: IUserRights;
    basicInfo: {
        headImgUrl: string;
        nickName: string;
    };
    onClose?: () => void;
}

const SubjectList = ({ subjects, projectName = '' }: { subjects: Subject[]; projectName?: string }) => (
    <span className="subject-list-box-hover">
        <div className="subject-list-box-hover-container">
            <div className="subject-list-box-container">
                <div className="subject-list-box-scroll-container">
                    <div className="subject-list-box">
                        <div className="tip-title">仅限于以下科目使用</div>
                        <div className="project-item">{projectName}</div>
                        <div className="list-box">
                            {subjects?.map(item => (
                                <div key={item.id} className="subject-item">
                                    {item.name}
                                </div>
                            ))}
                            {subjects?.length % 2 === 1 && <div className="subject-item" />}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <QuestionCircleOutlined />
    </span>
);

const Info = ({ userRights, basicInfo, onClose }: RightsInfoProps) => {
    const handleOpenBugRecordsModal = () => {
        eventBusExample.publish('RechargRecordModal', { type: 'open', params: { projectId: userRights?.projectId } });
    };

    return (
        <>
            <div className="rights-title-box">
                <div>
                    <span>权益</span>
                    {userRights?.projectName && <span className="project-item">{userRights.projectName}</span>}
                </div>
                <div className="rights-title-box__right-container">
                    <div className="rights-title-box__recharge-record" onClick={handleOpenBugRecordsModal}>
                        购买记录
                    </div>
                    <CloseOutlined onClick={onClose} />
                </div>
            </div>
            <div className="rights-user-info">
                <div className="user-info">
                    <img className="user-awater" src={basicInfo.headImgUrl} />
                    <span className="user-name">{basicInfo.nickName}</span>
                </div>
                {userRights && (
                    <div className="luca-info">
                        <span>
                            luca答疑 <span className="luca-info-weight">{userRights.lucaAskNum}</span>次
                        </span>
                        <span>
                            名师答疑
                            {userRights.subjects?.length > 0 && (
                                <SubjectList subjects={userRights.subjects} projectName={userRights.projectName} />
                            )}
                            <span className="luca-info-weight">{userRights.teacherAskNum}</span>次
                        </span>
                        {userRights.aiCorrectAuth && (
                            <span>
                                智能批改
                                {userRights.aiCorrectSubjects?.length > 0 && (
                                    <SubjectList subjects={userRights.aiCorrectSubjects} projectName={userRights.projectName} />
                                )}
                                <span className="luca-info-weight">{userRights.aiCorrectNum}</span>次
                            </span>
                        )}
                        {userRights.manualCorrectAuth && (
                            <span>
                                人工批改
                                {userRights.manualCorrectSubjects?.length > 0 && (
                                    <SubjectList subjects={userRights.manualCorrectSubjects} projectName={userRights.projectName} />
                                )}
                                <span className="luca-info-weight">{userRights.manualCorrectNum}</span>次
                            </span>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default Info;
